import { CompletionState } from '../moodleTypes/Module';

export function checkIsModuleCompleted(state: CompletionState | undefined) {
  return state === CompletionState.Complete || state === CompletionState.CompletePass;
}
